// const Comparator: (itemA: any, itemB: any) => 0|1|(-1)

interface AlphabetizeSortOptions {
  mode: 'ascending' | 'descending'
}

const basicSort: (stringA: string, stringB: string) => number = (stringA, stringB) => {
  const string_a = stringA.toLowerCase()
  const string_b = stringB.toLowerCase()
  return string_a.localeCompare(string_b)
}

const SortAlphabetically: (stringA: string, stringB: string, options?: AlphabetizeSortOptions) => number = (stringA, stringB, options) => {
  switch (options?.mode) {
    case 'descending':
      return Math.imul(basicSort(stringA, stringB), -1)
    case 'ascending':
    default:
      return basicSort(stringA, stringB)
  }
}

const Ascend: (stringA: string, stringB: string) => Number = (stringA, stringB) => SortAlphabetically(stringA, stringB, { mode: 'ascending' })
const Descend: (stringA: string, stringB: string) => Number = (stringA, stringB) => SortAlphabetically(stringA, stringB, { mode: 'descending' })

export const StringCompare = {
  SortAlphabetically,
  Ascend,
  Descend
}
